import {
    TextField,
    Button,
    Stack,
    Typography,
    IconButton,
} from '@mui/material';
import React, {useEffect, useState} from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import Dialog from "@mui/material/Dialog";
import {TransitionProps} from "@mui/material/transitions";
import Grow from "@mui/material/Slide";
import {IExhibitor, IInsertExhibitor} from "../../../common/interfaces/exhibitor";
import {DataGrid, GridColDef} from '@mui/x-data-grid';
import {deleteExhibitor, fetchExhibitor, fetchExhibitors, insertExhibitor, updateExhibitor} from "../../../api/exhibitors";
import Tooltip from "@mui/material/Tooltip";
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import {createToastNotification} from "../../../utilities/helpers";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import CancelIcon from '@mui/icons-material/Cancel';
import ConfirmationModal from "../../../components/ConfirmationModal";

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Grow in={true} ref={ref} {...props}/>;
});

export const ExhibitorListModal = ({
                                       fairID,
                                       floorPlanID,
                                       isVisible,
                                       setIsVisible,
                                       removeExhibitorFromObject
                                   }: any) => {

    // use state for stands - exhibitors
    const [eID, setEID] = useState<number | null>(null);
    const [eName, setEName] = useState<string>('');
    const [eDescription, setEDescription] = useState<string>('')
    const [eLink, setELink] = useState<string>('');
    const [eClass, setEClass] = useState<string>('');
    const [eBoothNumber, setEBoothNumber] = useState<string>('');
    const [eLogo, setELogo] = useState<File | 'unchanged' | null>(null);
    const [eLogoPreview, setELogoPreview] = useState<string | null>(null);
    const handleLogoUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.result) {
                    setELogo(file);
                    setELogoPreview(URL.createObjectURL(file));
                }
            };
            reader.readAsDataURL(file);
        }
    };
    const [confirmDeleteDialogIsOpened, setConfirmDeleteDialogIsOpened] = useState(false)

    const handleLogoRemove = () => {
        setELogo(null);
        setELogoPreview(null);
    };

    const clearInputForExhibitors = () => {
        setEID(null)
        setEName('')
        setEDescription('')
        setELink('')
        setEClass('')
        setEBoothNumber('')
        setELogo(null)
        setELogoPreview(null);
    }

    const handleFetchExhibitors = async (search?: string) => {

        if(!floorPlanID){
            return;
        }

        const data = {
            page: ePage,
            perPage: ePerPage,
            floorPlan:floorPlanID
        };

        if (search != undefined) {
            // @ts-ignore
            data.search = search
        }else if (eSearch.length > 0) {
            // @ts-ignore
            data.search = eSearch
        }

        try {
            let response = await fetchExhibitors(fairID, data);
            setExhibitorsData(response.exhibitors)
            setTotalExhibitors(response.totalItems)
        } catch (error: any) {
            createToastNotification('error', error?.response?.data?.message);
        }

    }

    const clearESearchInput = () => {
        setESearch('')
    }

    const handleERowClick = async (params: { row: { id: any } }) => {

        setEID(params.row.id)
        //@ts-ignore
        setEName(params.row.name)
        //@ts-ignore
        setEDescription(params.row.description)
        //@ts-ignore
        setEBoothNumber(params.row.boothNumber)
        //@ts-ignore
        setELink(params.row.link)
        //@ts-ignore
        setEClass(params.row.exhibitorClass)

        //@ts-ignore
        if (params.row.logoUrl) {
            //@ts-ignore
            setELogo('unchanged')
            //@ts-ignore
            setELogoPreview(params.row.logoUrl)
        } else {
            setELogo(null)
            setELogoPreview(null);
        }
    }

    const handleESave = async () => {

        const data: IInsertExhibitor = {
            floorPlanID: floorPlanID,
            name: eName,
            boothNumber: eBoothNumber,
            description: eDescription,
            link: eLink,
            exhibitorClass: eClass,
            file: eLogo,
            isUsed:true
        };

        try {
            let iResponse;
            if (eID) {
                iResponse = await updateExhibitor(eID, data);
            } else {
                iResponse = await insertExhibitor(data);
            }

            createToastNotification('success', iResponse.message)
            setIsVisible(false)
            clearInputForExhibitors()
        } catch (error: any) {
            createToastNotification('error', error?.response?.data?.message);
        }

    }

    const fetchExhibitorAndPopulateForm = async (exhibitorID:number) => {
        try {
            const response = await fetchExhibitor(exhibitorID)
            if(response.exhibitor){
                setEID(response.exhibitor.id ?? null);
                setEName(response.exhibitor.name ?? '');
                setEDescription(response.exhibitor.description ?? '')
                setEBoothNumber(response.exhibitor.boothNumber ?? '')
                setELink(response.exhibitor.link ?? '')
                setEClass(response.exhibitor.exhibitorClass ?? '')
                if(response.exhibitor.logoUrl){
                    setELogo('unchanged')
                    setELogoPreview(response.exhibitor.logoUrl)
                }else{
                    setELogo(null)
                    setELogoPreview(null);
                }
            }

        } catch (error: any) {
            createToastNotification('error', error?.response?.data?.message);
        }
    }

    const eColumns: GridColDef[] = [
        {field: 'id', headerName: 'ID', width: 70, sortable: false},
        {field: 'name', headerName: 'Naziv', flex:2, sortable: false},
        {field: 'boothNumber', headerName: 'Šifra štanda', flex:1, sortable: false},
        {field: 'description', headerName: 'Opis', type: 'string', flex:3, sortable: false},
        {field: 'exhibitorClass', headerName: 'Klasa', type: 'string', flex:1, sortable: false},
        {field: 'link', headerName: 'Link', type: 'string', flex:1, sortable: false},
        {
            field: 'isUsedText',
            headerName: '',
            type: 'string',
            flex:2,
            sortable: false,
            renderCell: (params) => (
                <strong style={{ color: params.row.isUsed ? "green" : "red" }}>
                    {params.row.isUsed ? "✅ Postavljen" : "❌ Nije postavljen"}
                </strong>
            )
        },
    ];

    const [exhibitorsData, setExhibitorsData] = useState<IExhibitor[]>( []);
    const [totalExhibitors, setTotalExhibitors] = useState<number>(0);
    const [eSearch, setESearch] = useState<string>('');
    const [ePage, setEPage] = useState<number>(1);
    const [ePerPage, setEPerPage] = useState<number>(5);
    const paginationModel = {page: ePage, pageSize: ePerPage};


    useEffect(() => {

        if (isVisible) {
            handleFetchExhibitors()
        }
    }, [isVisible, ePage, ePerPage]);

    useEffect(() => {

        if (isVisible === false) {
            clearInputForExhibitors()
            clearESearchInput()
        }
    }, [isVisible]);

    return (
        <Dialog
            fullWidth={true}
            maxWidth={'lg'}
            open={isVisible}
            onClose={() => {
                setIsVisible(false)
            }}
            TransitionComponent={Transition}
        >
            <Stack
                height='950px'
            >
                    <>
                        <Stack sx={{paddingTop: 5, paddingLeft: 5, paddingRight: 5}}>
                            <Stack direction="row" alignItems="center" justifyContent="space-between">
                                <Stack direction="row" alignItems="center" justifyContent="space-between">
                                    <Tooltip title="Zatvori" arrow>
                                        <IconButton
                                            sx={{marginRight: 1}}
                                            onClick={() => {
                                                setIsVisible(false)
                                            }}
                                        >
                                            <CancelIcon color='error'/>
                                        </IconButton>
                                    </Tooltip>
                                    <Typography>{eID ? 'Izmeni izlagača' : 'Novi izlagač'}</Typography>
                                </Stack>
                                <Stack direction="row" alignItems="center" justifyContent="space-between">
                                    <Tooltip title="Očisti unos" arrow>
                                        <IconButton
                                            sx={{marginRight:1}}
                                            onClick={()=>{
                                                clearESearchInput()
                                                clearInputForExhibitors()
                                                handleFetchExhibitors('')
                                            }}
                                        >
                                            <CleaningServicesIcon color="action" />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Obriši izlagača" arrow>
                                        <IconButton
                                            sx={{ marginRight: 1 }}
                                            onClick={() => {
                                                setConfirmDeleteDialogIsOpened(true);
                                            }}
                                        >
                                            <DeleteOutlineIcon color="error" />
                                        </IconButton>
                                    </Tooltip>
                                    <Button
                                        sx={{marginLeft:1}}
                                        variant="contained"
                                        color="success"
                                        onClick={handleESave}
                                    >
                                        Sačuvaj izlagača
                                    </Button>
                                </Stack>
                            </Stack>
                            <Stack direction="row" alignItems="start" justifyContent="space-between">
                                <Stack direction="column" alignItems="start" sx={{width:'90%'}}>
                                    <TextField
                                        size={'small'}
                                        sx={{width:'90%'}}
                                        label="Naziv *"
                                        name="name"
                                        value={eName}
                                        onChange={(e) => setEName(e.target.value)}
                                        margin="normal"
                                    />
                                    <TextField
                                        size={'small'}
                                        sx={{width:'90%'}}
                                        label="Broj štanda *"
                                        value={eBoothNumber}
                                        onChange={(e) => setEBoothNumber(e.target.value)}
                                        margin="normal"
                                        name="boothNumber"
                                    />
                                    <TextField
                                        size={'small'}
                                        sx={{width:'90%'}}
                                        label="Klasa izlagača"
                                        value={eClass}
                                        onChange={(e) => setEClass(e.target.value)}
                                        margin="normal"
                                        name="level"
                                    />
                                    <TextField
                                        size={'small'}
                                        sx={{width:'90%'}}
                                        label="Link"
                                        value={eLink}
                                        onChange={(e) => setELink(e.target.value)}
                                        margin="normal"
                                        name="link"
                                    />
                                </Stack>

                                <Stack direction="column" alignItems="start" justifyContent="space-between" sx={{width:'90%'}}>
                                    <TextField
                                        sx={{width:"90%"}}
                                        label="Opis"
                                        name="description"
                                        value={eDescription}
                                        onChange={(e) => setEDescription(e.target.value)}
                                        margin="normal"
                                        multiline
                                        rows={4}
                                    />
                                    <Stack spacing={2} marginTop={2} sx={{width:'90%'}}>
                                        {/*<Typography variant="body1">Logo</Typography>*/}
                                        {eLogoPreview && (
                                            <Stack direction="row" alignItems="center" spacing={1}>
                                                <img
                                                    src={eLogoPreview}
                                                    alt="Preview"
                                                    style={{
                                                        width: 100,
                                                        height: 100,
                                                        borderRadius: '50%',
                                                        objectFit: 'cover',
                                                    }}
                                                />
                                                <IconButton onClick={handleLogoRemove}>
                                                    <DeleteIcon color="error"/>
                                                </IconButton>
                                            </Stack>
                                        )}
                                        {eLogoPreview===null &&
                                            (<Button variant="outlined" component="label">
                                                Dodaj logo
                                                <input
                                                    name="logo"
                                                    type="file"
                                                    accept="image/*"
                                                    hidden
                                                    onChange={handleLogoUpload}
                                                />
                                            </Button>)}
                                    </Stack>
                                </Stack>
                            </Stack>

                            <Stack
                                sx={{
                                    marginTop: 1,
                                    marginBottom: 2,
                                    borderRadius: "20px",
                                    padding: '10px',
                                    paddingBottom: '0px',
                                    border: '1px solid #e0e0e0',
                                    backgroundColor: '#f9f9f9',
                                    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                                }}>
                                <Stack direction="row" alignItems="center">
                                    <TextField
                                        sx={{
                                            width: '500px',
                                            height: '50px',
                                            marginRight: '20px',
                                            '& .MuiInputBase-root': {
                                                backgroundColor: 'white',
                                                borderRadius: '5px',
                                                padding: 0,
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                borderColor: '#d0d0d0',
                                            },
                                        }}
                                        label="Pretraga"
                                        name="name"
                                        size="small"
                                        value={eSearch}
                                        onChange={(e) => {
                                            setESearch(e.target.value);
                                        }}
                                        margin="normal"
                                    />
                                    <Tooltip title="Pretraži">
                                        <IconButton
                                            onClick={()=>{
                                                handleFetchExhibitors()
                                            }}
                                            color="primary"
                                            size="medium"
                                            sx={{
                                                backgroundColor: '#f0f0f0',
                                                '&:hover': {
                                                    backgroundColor: '#e0e0e0',
                                                },
                                            }}
                                        >
                                            <SearchIcon />
                                        </IconButton>
                                    </Tooltip>

                                    {eSearch.length>0 &&
                                        <Tooltip title="Očisti unos">
                                            <IconButton
                                                onClick={()=>{
                                                    clearESearchInput()
                                                    handleFetchExhibitors('')
                                                }}
                                                color="error"
                                                size="medium"
                                                sx={{
                                                    marginLeft:1,
                                                    backgroundColor: '#f0f0f0',
                                                    '&:hover': {
                                                        backgroundColor: '#e0e0e0',
                                                    },
                                                }}
                                            >
                                                <ClearIcon />
                                            </IconButton>
                                        </Tooltip>}
                                </Stack>

                                <DataGrid
                                    disableColumnMenu
                                    disableRowSelectionOnClick
                                    rows={exhibitorsData}
                                    rowCount={totalExhibitors}
                                    columns={eColumns}
                                    onRowClick={handleERowClick}
                                    pagination
                                    paginationModel={{
                                        page: paginationModel.page - 1,
                                        pageSize: paginationModel.pageSize
                                    }}
                                    paginationMode={'server'}
                                    pageSizeOptions={[5, 10]}
                                    //@ts-ignore
                                    onPaginationModelChange={(model) =>{
                                        setEPage(model.page + 1)
                                        setEPerPage(model.pageSize)
                                    }}
                                    sx={{ border: 0 }}
                                    localeText={{
                                        MuiTablePagination: {
                                            labelRowsPerPage: "Redova po strani",
                                            labelDisplayedRows: ({from, to, count}) =>
                                                `${from} od ${count !== -1 ? count : ` od ${to}`}`,
                                        },
                                        noRowsLabel: "Nema dostupnih podataka",
                                    }}
                                />

                            </Stack>

                        </Stack>
                    </>
            </Stack>
            {confirmDeleteDialogIsOpened && (
                <ConfirmationModal
                    confirmationModalTitle="Brisanje izlagača"
                    cancelAction={() => {
                        setConfirmDeleteDialogIsOpened(false);
                    }}
                    handleAction={async () => {
                        if (eID) {
                            try {
                                await deleteExhibitor(eID);
                                removeExhibitorFromObject(eID)
                                setIsVisible(false)
                                createToastNotification('success', 'Izlagač je uspešno obrisan');
                            } catch (error: any) {
                                createToastNotification('error', error?.response?.data?.message);
                            }
                        }
                        setConfirmDeleteDialogIsOpened(false);
                    }
                    }
                    confirmBtnTitle="Potvrdi brisanje"
                    modalDescription="Da li ste sigurni da želite da obrišete izlagača iz sistema?"
                    cancelBtnTitle="Odustani"
                />
            )}
        </Dialog>
    );
};
